/* eslint-disable node/no-unsupported-features/es-syntax */
import { TRANSLATIONS_ROUTE_NAMES } from "@/shared";

export const TRANSLATIONS_ROUTES = [
    {
        name: TRANSLATIONS_ROUTE_NAMES.LIST,
        path: "/translations",
        meta: {
            title: "Переводы",
        },
        component: () => import("../ui/TranslationsList.vue"),
    },
    {
        name: TRANSLATIONS_ROUTE_NAMES.CREATE,
        path: "/translations/add",
        meta: {
            title: "Новый Перевод",
        },
        component: () => import("../ui/TranslationsEdit.vue"),
    },
    {
        name: TRANSLATIONS_ROUTE_NAMES.EDIT,
        path: "/translations/:id",
        meta: {
            title: "Редактирование Перевода",
        },
        component: () => import("../ui/TranslationsEdit.vue"),
        props: true,
    },
];
